export default __webpack_public_path__ + "0ad8ff654a017b07fcce971aa371e230.png";